import React, { useEffect, useState } from "react";
import { HiPlusSm } from "react-icons/hi";
import WorkerAvailabiltyModal from "components/Modals/WorkerAvailabiltyModal";
import { convertTo12HourFormat } from "Utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  getSpRosteringSetting,
  getSpRosteringSettingLoader,
} from "store/selector/sp.selector";
import { spRosteringSettingsRequest } from "store/actions/sp.actions";

const WorkerAvailabilty = ({
  WorkerId,
  setRefreshPageForWorkerTimeSlot,
  worker,
  isWorkerAvailablity,
  isUserGracePeriodOver,
}) => {
  const [openModal, setOpenModal] = React.useState(false);

  // Parse the JSON data for worker availability

  const [spRosteringSetting, setSpRosteringSetting] = useState(null);

  const dispatch = useDispatch();
  const spRosteringSettingLoader = useSelector(getSpRosteringSettingLoader);
  const spRosteringSettingFromStore = useSelector(getSpRosteringSetting);

  useEffect(() => {
    dispatch(spRosteringSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (spRosteringSettingFromStore) {
      setSpRosteringSetting(spRosteringSettingFromStore);
    }
  }, [spRosteringSettingFromStore]);

  const availabilityData =
    worker?.availability && JSON.parse(worker?.availability);

  return (
    <div>
      <label className='text-md font-bold'>
        {spRosteringSetting?.is_availability
          ? "Worker Availability"
          : "Worker Unavailability"}
      </label>
      <div className='mt-1 mb-10'>
        <div className='flex justify-end text-blue-400 '>
          <div
            className='flex items-center cursor-pointer '
            onClick={() => setOpenModal(true)}
          >
            <span>
              <HiPlusSm />
            </span>
            <span className='text-sm font-semibold'>
              {spRosteringSetting?.is_availability
                ? "Add Availability"
                : "Add Unavailability"}
            </span>{" "}
          </div>
        </div>
        <div className='overflow-x-auto mt-1'>
          <table className='border border-collapse w-full'>
            <thead>
              <tr className='bg-[#e1e5f0]'>
                <th className='border p-2'>Day</th>
                <th className='border p-2'>
                  {spRosteringSetting?.is_availability
                    ? "Availability"
                    : "Unavailability"}
                </th>
              </tr>
            </thead>
            {availabilityData ? (
              <tbody>
                {/* Render availability data for each day */}
                {Object.keys(availabilityData).map((day) => (
                  <tr key={day}>
                    <td className='border p-2 capitalize text-center'>{day}</td>
                    <td className='border p-2'>
                      {availabilityData[day]?.length > 0 ? (
                        <ul className='text-center'>
                          {availabilityData[day].map((slot, index) => (
                            <li key={index}>
                              {slot.from && slot.to
                                ? `${convertTo12HourFormat(
                                    slot.from
                                  )} - ${convertTo12HourFormat(slot.to)}`
                                : "Available"}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span className='text-red-500'>Not available</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan='2'>
                    <div className='text-sm text-center text-gray-500 p-3'>
                      No data available
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      {openModal && (
        <WorkerAvailabiltyModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          openModel={openModal}
          handleClose={setOpenModal}
          WorkerId={WorkerId}
          setRefreshPageForWorkerTimeSlot={setRefreshPageForWorkerTimeSlot}
          TimeSlots={availabilityData}
          isWorkerAvailablity={isWorkerAvailablity}
          isAvailabilityMode={spRosteringSetting?.is_availability} // Pass the mode dynamically
        />
      )}
    </div>
  );
};

export default WorkerAvailabilty;
